import socketIOClient from "socket.io-client";
const ENDPOINT = process.env.REACT_APP_PUBLIC_URL.toString().substring(0, process.env.REACT_APP_PUBLIC_URL.toString().length - 1);
const socket = socketIOClient(ENDPOINT, {
    autoConnect: false
});
class AdmisionSocket {
    async updateSystemListAdmision() {
        return new Promise(function (resolve, reject) {
            try {
                socket.on("updateListAdmisionsConn", function (data) {
                    resolve();
                });
            }
            catch (err) {
                resolve();
            }
        });
    }
}
export default new AdmisionSocket();
